import { render, staticRenderFns } from "./t2.vue?vue&type=template&id=368c53d8&scoped=true&"
import script from "./t2.vue?vue&type=script&lang=js&"
export * from "./t2.vue?vue&type=script&lang=js&"
import style0 from "./t2.vue?vue&type=style&index=0&id=368c53d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c53d8",
  null
  
)

export default component.exports